import type { ChecklistItem, ProjectNode } from '@/shared/types/projectData';

type ChecklistCompatibleNode = Partial<ProjectNode> & {
  checklists?: ChecklistItem[];
};

export const supportsNodeChecklist = (nodeType: string | null | undefined): nodeType is 'task' => (
  nodeType === 'task'
);

export const getNodeChecklist = (
  node: ChecklistCompatibleNode | null | undefined,
): ChecklistItem[] => {
  if (!node) return [];
  if (!supportsNodeChecklist(node.type)) return [];
  if (Array.isArray(node.checklist)) return node.checklist;
  if (Array.isArray(node.checklists)) return node.checklists;
  return [];
};

export const withCanonicalChecklist = <T extends ChecklistCompatibleNode>(node: T): T & { checklist: ChecklistItem[] } => {
  const checklist = getNodeChecklist(node);
  const canonicalNode = {
    ...node,
    checklist,
  } as T & { checklist: ChecklistItem[]; checklists?: ChecklistItem[] };

  if (!supportsNodeChecklist(node.type)) {
    canonicalNode.checklists = [];
  } else {
    canonicalNode.checklists = checklist;
  }

  return canonicalNode;
};
